import { render } from "./AchievementPage.vue?vue&type=template&id=fac68d2a&scoped=true"
import script from "./AchievementPage.vue?vue&type=script&lang=js"
export * from "./AchievementPage.vue?vue&type=script&lang=js"

import "./AchievementPage.vue?vue&type=style&index=0&id=fac68d2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fac68d2a"]])

export default __exports__